import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home, Service } from "./pages";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="service/:serviceId" element={<Service />} />
      </Routes>
    </Router>
  );
}

export default App;
